import React from 'react'
import styled from '@emotion/styled'
import { GoogleIcon } from '../../assets/icons/social'
import useSocialAuth from '../../hooks/use-social-auth'
import Button from '../shared/button'

const Icon = styled.svg`
  width: ${p => p.theme.space[5]};
  height: ${p => p.theme.space[5]};
  margin-right: ${p => p.theme.space[4]};
`

const BaseButton = ({ children, icon, ...rest }) => (
  <Button variant="social" {...rest}>
    <Icon as={icon} />
    {children}
  </Button>
)

export const GoogleButton = ({ next, ...rest }) => {
  const { startGoogleSignUp } = useSocialAuth(next)
  return <BaseButton icon={GoogleIcon} {...rest} onClick={startGoogleSignUp} />
}
